<app-student-nav></app-student-nav>

<div class="hm-page">
  <app-profile-strip />

  <div class="hm-bottom">
    <main class="hm-feed" aria-label="Activity feed">
      <app-feed-column />
    </main>

    <aside class="hm-sidebar-right" aria-label="Sidebar">
      <app-calendar-widget />
      <app-upcoming-deadlines />
      <app-careerss-to-explore />
    </aside>
  </div>
</div>

<app-messaging-widget></app-messaging-widget>
